<template>
  <div
    class="dialog-sidebar mr-6 flex w-[17rem] flex-col border-r pr-6"
  >
    <!-- TODO: primeui cssLayer for !justify-start -->
    <Button
      v-for="(tab, tabIndex) in tabs"
      :key="tab.name"
      type="button"
      :label="$te(tab.label) ? $t(tab.label) : tab.label"
      severity="secondary"
      :text="activeTabName !== tab.name"
      class="m-0 !justify-start truncate"
      :class="{ 'mb-1': tabIndex < tabs.length - 1 }"
      @click="activeTabName = tab.name"
    >
      <template #icon>
        <LucideIcon :icon="tab.icon" />
      </template>
    </Button>

    <template v-if="$slots.bottom">
      <Divider />
      <slot name="bottom" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import LucideIcon from '~/components/ui/LucideIcon.vue'

const activeTabName = defineModel<string>('activeTabName')

defineProps<{
  tabs: { label: string, icon: string, name: string }[]
}>()
</script>

<style lang="scss" scoped>
.dialog-sidebar {
  border-color: var(--p-content-border-color);
}
</style>
